import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"_-1SP1","textWrapNowrap":"_4uO83","alignRight":"CjrJp","alignCenter":"ohx--","sizeFullWidth":"nACCD","renderedInTable":"-PI6m","sizeOriginal":"Xwd7-","sizeContent":"F9R-i","sizeSmall":"KZEwE","sizeSmallCenter":"Q3AP4","flex":"WnBQx","atomic":"MqyZT","anchor":"BNvla","embed":"QQiQa","horizontalScrollbar":"lmY35","pluginContainerMobile":"_5IExH"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-10a871be.js.map
